import {
  createContext,
  useContext,
  useEffect,
  type Dispatch,
  type SetStateAction,
} from 'react';

export type AuthProgressStep = 1 | 2 | 3 | 4 | 5;

export const AuthProgressContext = createContext<
  Dispatch<SetStateAction<AuthProgressStep | null>> | undefined
>(undefined);

export function useAuthProgressStep(step: AuthProgressStep | null) {
  const setProgressStep = useContext(AuthProgressContext);

  useEffect(() => {
    setProgressStep?.(step);
    return () => setProgressStep?.(null);
  }, [setProgressStep, step]);
}
